export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00987.37a39764.png";